<template>
  <section>
    <div class="keywords">
        <h1>キーワードとマッチする検索結果</h1>
        <p class="match_flag" v-if="!match_flag">マッチするキーワードがありません</p>
        <div v-for="article in articles" :key="article.id">
            <div v-for="a in article.contents" :key="a.id">
                <h3>{{a.title}}</h3>
                <div v-html="a.content"></div>
                <hr/>
            </div>
        </div>
        <h2>キーワードを含む検索結果</h2>
        <p class="relate_flag" v-if="!relate_flag">該当するキーワードがありません</p>
        <div v-for="relate_article in relate_articles" :key="relate_article.id">
            <div v-for="r in relate_article.contents" :key="r.id"> 
                <h3>{{r.title}}</h3>
                <div v-html="r.content"></div>
                <hr/>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import store from '@/store';
export default {
  components: {},
  data() {
    return {
      articles:[],
      relate_articles:  [],
      match_flag: false,
      relate_flag: false
    };
  },
  created() {
    store.commit('start')
    var change_array = this.$route.params.id.split(/\s+/);
    console.log(change_array)
    for(let i = 0; i < change_array.length; i++) {
    var url = "https://dream.microcms.io/api/v1/article?filters=title[equals]" + change_array[i] + "&limit=10"
            axios
                .get(url, {
                headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
                })
                .then(res => {
                    store.commit('end');
                    if(res.data.totalCount != 0){
                        this.articles.push(res.data)
                        this.match_flag = true
                    }
                })
                .catch(err => {
                store.commit('end');
                console.log(err);
            });
    }
    for(let i = 0; i < change_array.length; i++) {
        var relate_url = "https://dream.microcms.io/api/v1/article?filters=title[contains]" + change_array[i] + "&limit=100"
            axios
                .get(relate_url, {
                headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
                })
                .then(res => {
                if(res.data.totalCount != 0){
                    this.relate_articles.push(res.data)
                    this.relate_flag = true
                }
                })
                .catch(err => {
                console.log(err);
            });
        }
    const title = "複数キーワード検索結果｜夢占い辞典ゆめみん"
    const description = "複数キーワード検索結果画面です。｜夢占い辞典ゆめみん"
    const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
    const og_image = 'https://dream.ameneko.com/topImage.jpeg'
    document.title = title
    document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
    document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)  
  },
  watch: {
    '$route' (to) {
        this.$router.go(to.params.id)
    }
  },
}
</script>

<style scoped>
.keywords{
  max-width: 500px;
  margin: auto;
  padding:20px;
}
.card-content{
  padding: 8px;
}
h1{
  font-weight: bold;
  font-size: 1.3em;
  text-align: center;
  padding-bottom: 30px;
}
div >>> h2{
  font-weight: bold;
  font-size: 1.3em;
  padding-bottom: 10px;
  text-align: center;
}
div >>> h3{
  font-weight: bold;
  font-size: 1.1em;
  padding-top: 10px;
  padding-bottom: 10px;
}
div >>> li{
  font-size: 1.1em;
  padding-top: 5px;
}
.match_flag{
    text-align: center;
    padding-bottom: 20px;
}
.relate_flag{
    text-align: center;
    padding-bottom: 20px;
}
</style>